import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/park/pass/out/rule/list/v2', Object.assign({}, options, {
    params
  }));

export const getDetail = (params, options) =>
  request.get('/api/park/pass/out/rule/detail/v2', Object.assign({}, options, {
    params
  }));

export const remove = (params, options) =>
  request.post('/api/park/pass/out/rule/remove/v2', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/park/pass/out/rule/submit/v2', params, options);

export const update = (params, options) =>
  request.post('/api/park/pass/out/rule/submit/v2', params, options);
